@if (control && control.touched && control.errors) {
  <div class="text-danger">
    @if (control.errors.required && language!=='German') {
      <div>{{controlName}} is required.</div>
    }
    @if (control.errors.required && language ==='German') {
      <div>{{controlName}} ist erforderlich.</div>
    }
    @if (control.errors.whitespace) {
      <div>{{controlName}} should not contain whitespace.</div>
    }
    @if (control.errors.maxlength) {
      <div>{{controlName}} should only contain {{control.errors.maxlength.requiredLength}} characters but found {{control.errors.maxlength.actualLength}} character(s).</div>
    }
    @if (control.errors.editorMaxChar) {
      <div>{{controlName}} should only contain 3000 characters but found {{control.errors.count}} character(s).</div>
    }
    @if (control.errors.digits) {
      <div>{{controlName}} should only contain digits.</div>
    }
    @if (control.errors.email) {
      <div>Invalid email format.</div>
    }
    @if (control.errors.rangeLength) {
      <div>{{controlName}} should have 11 digits.</div>
    }
    @if (control.errors.owlDateTimeMin) {
      <div>
        Selected data time {{ getFormattedDate(control.errors.owlDateTimeMin.actual) }}  is greater than minimum date {{ getFormattedDate(control.errors.owlDateTimeMin.min)}}.
      </div>
    }
    @if (control.errors.pattern) {
      <div>
        <ng-content select=".pattern-error">
        </ng-content>
      </div>
    }
  </div>
}
